'use client';
import React from 'react';

const PostsGeneral = () => {
  return <div></div>;
};

export default PostsGeneral;
